import {
	get,
	create,
	update,
	findByUserAndRange,
	getValorTotalMetasDiarias,
	deleteUsuarioMeta,
	deleteMeta,
	importarMetasDiarias,
	batch,
} from '@/api/metaDiaria'
import { MetaDiaria } from '@/models/MetaDiaria';
import type { MetaDiariaBatchItem } from '@/api/metaDiaria';
import { MetaDiariaServiceAdapter } from '@/usecases/metaDiaria/adapter';
import { injectable } from 'inversify-props';


@injectable()
export class MetaDiariaService implements MetaDiariaServiceAdapter {
	get = async (id: string) => await get(id)
	create = async (meta: MetaDiaria) => await create(meta)
	update = async (meta: MetaDiaria) => await update(meta)
	findByUserAndRange = async (metaId: string, userId: string, start: string, end: string) =>
		await findByUserAndRange(metaId, userId, start, end)
	getValorTotalMetasDiarias = async (metaId: string, start: string, end: string) =>
		await getValorTotalMetasDiarias(metaId, start, end)
	deleteUsuarioMeta = async (metaId: string, id: string) => 
		await deleteUsuarioMeta(metaId, id)
	deleteMeta = async (metaId: string) => 
		await deleteMeta(metaId)
	importarMetasDiarias = async (metaId: string, mes: number, ano: number, urlDoArquivo: string) => await importarMetasDiarias(metaId, mes, ano, urlDoArquivo)
	salvarBatch = async (itens: MetaDiariaBatchItem[]) => await batch(itens)

}